module.exports = __webpack_public_path__ + "img/13.ee9693a0.jpg";